
export default {
  SEND_MEASUREAMENT: 'sendMeasureament',
  CHANGE_JDE_STATUS: 'changeJdeStatus'
}
